import AjaxLoadedWebsiteModal from "webPage/modal/AjaxLoadedWebsiteModal";
import SimpleFormHandler from "util/SimpleFormHander";

export default class requestDemoModal extends AjaxLoadedWebsiteModal {
    constructor(page) {
        super(page, ".js-modal-content");
    }

    handleContent($elem) {
        let me = this;
        this.$modal.find(".modal__content").append($elem);
        this.$modal.find('.btn').removeAttr('disabled');
        new SimpleFormHandler(this.$modal.find('.js-demo-request'), 'demo-request-orange', {}, true);
    }
}
